import React from "react";
import DashboardBroadcastTabs from "./DashboardBroadcastTabs";

const DashboardBroadcastList: React.FC = () => <DashboardBroadcastTabs />;

export default DashboardBroadcastList;
